import React, {FC, useCallback} from 'react'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import {useRecreacion} from '../../../hooks/useRecreacion'
import {renderPanelContent} from './components'
import {TabsContent} from '../../../components/UI/Tab'
import 'react-tabs/style/react-tabs.scss'

const RecreacionPageWrapper: FC = React.memo(() => {
  const {tabs, deleteTab, changeTab, currentTab} = useRecreacion()
  let totalArrays = tabs.length - 1

  const handleDeleteTab = (event: any, id: number) => {
    event.stopPropagation()
    let key = totalArrays === id ? id - 1 : id
    changeTab(key)
    deleteTab(id)
  }

  const handleCurrentKey = useCallback((id: number) => {
    changeTab(id)
  }, [])
  return (
    <>
      <Tabs selectedIndex={currentTab} onSelect={(index) => handleCurrentKey(index)}>
        <TabList className={'sdx_tab_panel px-0'}>
          {tabs.map((item, index) => {
            return (
              <Tab key={index} className={'sdx_tab_panel_option'}>
                <TabsContent
                  name={item.title}
                  idIndex={index}
                  idCurrent={Number(currentTab)}
                  closeTab={item.id !== 0}
                  onclickD={(e) => handleDeleteTab(e, index)}
                />
              </Tab>
            )
          })}
        </TabList>
        {tabs.map((item, index) => {
          return <TabPanel key={index}>{renderPanelContent(item.submenu)}</TabPanel>
        })}
      </Tabs>
    </>
  )
})

export default RecreacionPageWrapper
